import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import Home from './pages/Home';
import Blogs from './pages/Blogs';
import Admin from './pages/Admin';
import NotFound from './pages/NotFound';
import Projects from './pages/Projects';
import Ask from './pages/Ask';
import About from './pages/About';
import Contact from './pages/Contact';

export default function App() {
  return (
    <div>
      <Router>
        <Switch>
          <Route path='/' component={Home} exact />
          <Route path='/blogs' component={Blogs} />
          <Route path='/admin' component={Admin} />
          <Route path='/projects' component={Projects} />
          <Route path='/ask' component={Ask} />
          <Route path='/about' component={About} />
          <Route path='/contact' component={Contact} />
          <Route component={NotFound} />
        </Switch>
      </Router>
    </div>
  );
}
